export const GENDER = [
    {
        code: "ML",
    },
    {
        code: "FM",
    },
    {
        code: "OTHER",
    },
    {
        code: "NONE",
    },
];